import { baseRoute } from '../../constants/routes';

export const CALENDAR_ROUTE = baseRoute + '/calendars';
export const CALENDAR_PLAYER_ROUTE = baseRoute + '/calendar';
export const CALENDAR_DUPLICATE_ROUTE = baseRoute + '/calendars/duplicate';
export const DOOR_DROP_ROUTE =  baseRoute + '/calendars/order-hatches';

export const CREATE_CALENDAR = 'CREATE_CALENDAR';
export const CREATE_CALENDAR_SUCCESS = 'CREATE_CALENDAR_SUCCESS';

export const DELETE_CALENDAR = 'DELETE_CALENDAR';
export const DELETE_CALENDAR_SUCCESS = 'DELETE_CALENDAR_SUCCESS';

export const FILTER_CALENDAR = 'FILTER_CALENDAR';
export const FILTER_CALENDAR_SUCCESS = 'FILTER_CALENDAR_SUCCESS';

export const CLEAR_CREATED_CALENDAR = 'CLEAR_CREATED_CALENDAR';

export const GET_PLAYER_CALENDAR = 'GET_PLAYER_CALENDAR';
export const GET_PLAYER_CALENDAR_SUCCESS = 'GET_PLAYER_CALENDAR_SUCCESS';

export const GET_ALL_CALENDARS = 'GET_ALL_CALENDARS';
export const GET_ALL_CALENDARS_SUCCESS = 'GET_ALL_CALENDARS_SUCCESS';

export const GET_CALENDAR = 'GET_CALENDAR';
export const GET_CALENDAR_SUCCESS = 'GET_CALENDAR_SUCCESS';

export const UPDATE_CALENDAR = 'UPDATE_CALENDAR';
export const UPDATE_CALENDAR_SUCCESS = 'UPDATE_CALENDAR_SUCCESS';

export const DUPLICATE_CALENDAR = 'DUPLICATE_CALENDAR';
export const DUPLICATE_CALENDAR_SUCCESS = 'DUPLICATE_CALENDAR_SUCCESS';

export const UPDATE_DOOR_DRAG_DROP = 'UPDATE_DOOR_DRAG_DROP';
export const UPDATE_DOOR_DRAG_DROP_SUCCESS = 'UPDATE_DOOR_DRAG_DROP_SUCCESS';
